export default {
  methods: {
    openDialog() {
      this.globalEmitter.emit('openInsertSnippetDialog');
    }
  }
};
